import Raven from 'raven-js'
import axios from 'axios'
import urls from '../constants/urls'
import version from '../constants/version'

export const isPullRequestApp = (urls.reviewAppUrl !== '')

export const setupAxios = () => {
  axios.defaults.headers.post['Content-Type'] = 'application/json'
}

export const setupRaven = () => {
  Raven.config(import.meta.env.VITE_RAVEN_DSN, {
    release:     version,
    environment: import.meta.env.MODE
  }).install()
}
